import {
  EmptyState,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faFolder } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

type NoKnowledgeBasesProps = {
  onPrimaryAction: () => void;
};

export const NoKnowledgeBases = ({
  onPrimaryAction,
}: NoKnowledgeBasesProps) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faFolder}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={
          <FormattedMessage id="knowledge_base.empty_state.no_folder.title" />
        }
        message={
          <FormattedMessage id="knowledge_base.empty_state.no_folder.message" />
        }
        primaryCTA={
          <EmptyState.CallToAction.Primary
            onClick={onPrimaryAction}
            leftIcon={<FontAwesomeIcon icon={faPlus} size={12} />}
          >
            <FormattedMessage id="knowledge_base.action.create_knowledge_base" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};
